import { render, staticRenderFns } from "./ListFooter.vue?vue&type=template&id=da637f6e&scoped=true"
import script from "./ListFooter.vue?vue&type=script&lang=js"
export * from "./ListFooter.vue?vue&type=script&lang=js"
import style0 from "./ListFooter.vue?vue&type=style&index=0&id=da637f6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da637f6e",
  null
  
)

export default component.exports